(() => {
  const SUNFLOWER_HANDLE = 'golden-sunflower-garden-charm-bracelet';
  const replacements = new Map([
    ['Breathable Mesh Comfort', 'Garden-Inspired Charm Design'],
    ['Secure Stay-Put Fit', 'Easy Everyday Bracelet Style'],
    ['Cushioned Heel & Toe Support', 'Sunflower, Bee, Ladybug, Star & Heart Charms'],
    ['5 Pairs in Every Pack', 'Golden Finish with Cheerful Yellow Accents']
  ]);
  function fixSunflowerBenefits() {
    if (!location.pathname.includes(`/products/${SUNFLOWER_HANDLE}`)) return;
    const root = document.querySelector('.product-information') || document.querySelector('main') || document.body;
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const current = (node.nodeValue || '').trim();
      const replacement = replacements.get(current);
      if (!replacement) return;
      node.nodeValue = node.nodeValue.replace(current, replacement);
    });
  }
  let queued = false;
  const scheduleFix = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fixSunflowerBenefits(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleFix, { once: true }); else scheduleFix();
  new MutationObserver(scheduleFix).observe(document.documentElement, { childList: true, subtree: true });
})();
